"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-async-promise-executor */
require("./types/index");
class Action {
    constructor(data, actionType) {
        this.actionType = actionType;
        this.data = data;
    }
    execute() {
        switch (this.actionType) {
            case 'ADD':
                return this.executeAdd();
            case 'MODIFY':
                return this.executeModify();
            case 'GET_CART':
                return this.executeGetCart();
            case 'CLEAR_CART':
                return this.executeClearCart();
        }
    }
    createAbsoluteURL(relPath) {
        return `${window.location.protocol}//${window.location.host}${relPath}`;
    }
    executeAdd() {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await fetch(this.createAbsoluteURL('/cart/add.js'), {
                    method: 'POST',
                    body: JSON.stringify({
                        items: this.data.map((item) => ({
                            id: item.id,
                            quantity: item.quantity || 1,
                            properties: item.properties ? Object.assign({}, item.properties) : undefined,
                        })),
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                return resolve(res);
            }
            catch (e) {
                return reject(e);
            }
        });
    }
    executeModify() {
        return new Promise(async (resolve, reject) => {
            const itemToModify = this.data[0];
            try {
                const res = await fetch(this.createAbsoluteURL(`/cart/change.js`), {
                    method: 'POST',
                    body: JSON.stringify({
                        id: itemToModify.id,
                        quantity: itemToModify.hasOwnProperty('quantity')
                            ? itemToModify.quantity
                            : 0,
                        properties: (itemToModify === null || itemToModify === void 0 ? void 0 : itemToModify.properties) ? Object.assign({}, itemToModify === null || itemToModify === void 0 ? void 0 : itemToModify.properties) : undefined,
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                return resolve(res);
            }
            catch (e) {
                return reject(e);
            }
        });
    }
    executeGetCart() {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await fetch(this.createAbsoluteURL(`/cart.js`));
                const data = await res.json();
                return resolve(data);
            }
            catch (err) {
                return reject(err);
            }
        });
    }
    executeClearCart() {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await fetch(this.createAbsoluteURL(`/cart/clear.js`), {
                    method: 'POST',
                });
                const data = await res.json();
                return resolve(data);
            }
            catch (err) {
                return reject(err);
            }
        });
    }
}
exports.default = Action;
